<template>
  <cat-btn
    v-if="helpExists"
    :id="triggerId"
    small
    link
    class="cat-help-trigger"
    icon="question-light"
    :hint="triggerTitle"
    :show-hint="false"
    @ui-click="emitClick"
  ></cat-btn>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import CatBtn from "@/components/catBtn/catBtn";
import { checkHelpSource } from "@/components/catPageTemplate/pageHelpMixin";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },
  name: "CatHelpTrigger",
  components: { CatBtn },
  props: {
    title: {
      type: String,
      description: "Accessible name to identify this help trigger."
    },
    url: {
      type: String,
      description: "External help content URL"
    },
    sourceId: {
      type: String,
      description: "Unique source ID to use for the help trigger."
    }
  },
  data: function () {
    return {
      helpExists: false,
      dataUrl: this.url
    };
  },
  computed: {
    triggerTitle: function () {
      var title = this.title ? this.title + " " : "";
      return title + this.resolveTxt("skin.help.guide", "Help guide");
    },
    triggerId: function () {
      return this.sourceId ? this.sourceId + "-help-trigger" : undefined;
    }
  },
  watch: {
    dataUrl: function (newval, oldval) {
      this.dataUrl = newval;
    }
  },
  mounted: function () {
    this.checkHelp();
  },
  methods: {
    emitClick: function () {
      var detail = {
        url: this.dataUrl,
        sourceId: this.triggerId ? this.triggerId + "_btn" : undefined, // _btn is to match added by catBtn component
        sourceTitle: this.triggerTitle,
        sectionHelp: true
      };

      this.$emit("ui-click", detail);

      var evt = new CustomEvent("ui-show-page-help", {
        detail: detail
      });
      document.dispatchEvent(evt);
    },
    checkHelp: function () {
      if (this.suppressExternalHelp) {
        this.helpExists = false;
        return;
      }
      var _t = this;
      var cb = function (exists) {
        _t.helpExists = exists;
      };
      checkHelpSource(this.dataUrl, cb);
    }
  }
});
</script>
